module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sz-540261e12114fd44d91743481382dee3.svg";